import { watchImportFileCSV } from 'store/global/importCSV/sagas/watchImportCSV';

export const sagaImportFile = [watchImportFileCSV];
